import React, { Component } from "react";
import {
  Form,
  Accordion,
  Input,
  Select,
  Icon,
  Label,
  Checkbox,
  Button,
  Message
} from "semantic-ui-react";
import { translate } from "react-i18next";

class EditUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],
      modPass: -1,
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      error: { hidden: true, header: "Errore", content: "error" },
      successMessage: true
    };
  }

  componentDidMount() {
    let roleIndex = this.props.roles.findIndex(
      role => role.id === this.props.loggedRole_id
    );
    let tmpRoles = this.props.roles.filter(
      role => this.props.roles[roleIndex].weight >= role.weight
    );
    tmpRoles = tmpRoles.map(role => {
      return { text: role.role_desc, value: role.id };
    });

    this.setState({ roles: tmpRoles });
  }

  handlePassword(type, e) {
    switch (type) {
      case "old":
        this.setState({ oldPassword: e.target.value });
        this.props.oldPassChange(e.target.value);
        break;
      case "new":
        this.setState({ newPassword: e.target.value });
        this.props.newPassChange(e.target.value);
        break;
      case "repeat":
        this.setState({ repeatPassword: e.target.value });
        this.props.repeatPassChange(e.target.value);
        break;
      default:
        break;
    }
  }

  updatePassword() {
    let localError = Object.assign({}, this.state.error);

    if (this.state.newPassword !== "" && this.state.repeatPassword !== "") {
      if (this.state.newPassword === this.state.repeatPassword) {
        let myHeadersToken = new Headers();
        myHeadersToken.append("Content-Type", "application/json");

        const username = JSON.stringify({ username: this.props.username });

        let requestOptionsToken = {
          method: "POST",
          headers: myHeadersToken,
          body: username,
          redirect: "follow"
        };

        // Get new secret token
        fetch(window.env.GenerateSecretToken, requestOptionsToken)
          .then(response => response.json())
          .then(result => {
            if (result.secret_token) {
              let myHeadersPassword = new Headers();
              myHeadersPassword.append("Content-Type", "application/json");

              const body = JSON.stringify({
                secret_token: result.secret_token,
                password: this.state.newPassword,
                resetLastLogin: true
              });

              let requestOptions = {
                method: "POST",
                headers: myHeadersPassword,
                body,
                redirect: "follow"
              };

              // Change password
              fetch(window.env.UpdatePassword, requestOptions)
                .then(response => response.text())
                .then(result => {
                  if (result === "OK") {
                    localError.hidden = true;
                    this.setState({
                      error: localError,
                      successMessage: !this.state.successMessage
                    });
                  } else {
                    // PASSWORD ERROR
                    localError.content = this.props.t("PWD_APIERROR");
                    localError.hidden = false;
                    this.setState({ error: localError, successMessage: true });
                  }
                })
                .catch(error => console.log("error", error));
            } else {
              // ERROR in secret token
              localError.content = result.error || "Error";
              localError.hidden = false;
              this.setState({ error: localError, successMessage: true });
            }
          })
          .catch(error => console.log("error", error));
      } else {
        // ERROR in data
        localError.content = this.props.t("PWD_MISMATCH");
        localError.hidden = false;
        this.setState({ error: localError, successMessage: true });
      }
    } else {
      // ERROR in data
      localError.content = this.props.t("PWD_FILLFORM");
      localError.hidden = false;
      this.setState({ error: localError, successMessage: true });
    }
  }

  render() {
    let labelPassword;
    if (
      this.state.oldPassword !== "" ||
      this.state.newPassword !== "" ||
      this.state.repeatPassword !== ""
    ) {
      if (this.state.newPassword === this.state.repeatPassword) {
        labelPassword = (
          <Label color="green" pointing="left">
            Le password inserite coincidono!
          </Label>
        );
      } else {
        labelPassword = (
          <Label color="red" pointing="left">
            Le password inserite non coincidono!
          </Label>
        );
      }
    }

    const { t } = this.props;

    return (
      <Form>
        <Form.Group widths="equal">
          <Form.Field
            control={Input}
            label="Nome"
            value={this.props.name}
            onChange={this.props.nameChange()}
          />
          <Form.Field
            control={Input}
            label="Email"
            value={this.props.email}
            onChange={this.props.emailChange()}
          />
          {this.props.mode && this.props.mode === "admin" ? (
            <Form.Field
              control={Input}
              label="Username"
              value={this.props.username}
              onChange={this.props.usernameChange()}
            />
          ) : null}
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field
            control={Input}
            label="Organizzazione"
            value={this.props.organization}
            onChange={this.props.orgChange()}
          />
          <Form.Field
            control={Input}
            label="Sito Web"
            value={this.props.link_web}
            onChange={this.props.linkWebChange()}
          />
          {this.props.mode && this.props.mode === "admin" ? (
            <Form.Field
              control={Select}
              label="Ruolo"
              options={this.state.roles}
              onChange={this.props.roleChange()}
              defaultValue={this.props.role_id}
            />
          ) : null}
        </Form.Group>
        {!this.props.self ? (
          <Form.Field
            control={Checkbox}
            label="Utente bloccato"
            toggle
            checked={!this.props.status}
            onChange={this.props.statusChange.bind(this)}
          />
        ) : null}
        <Accordion as={Form.Field}>
          <Accordion.Title
            active={this.state.modPass === 0}
            index={0}
            onClick={(e, titleProps) => {
              titleProps.index === this.state.modPass
                ? this.setState({ modPass: -1 })
                : this.setState({ modPass: 0 });
            }}
          >
            <Icon name="dropdown" />
            Modifica password
          </Accordion.Title>
          <Accordion.Content active={this.state.modPass === 0}>
            {this.props.mode && this.props.mode === "user" ? (
              <Form.Field inline width={16}>
                <input
                  placeholder="Vecchia password"
                  onChange={this.props.oldPassChange()}
                  type="password"
                  style={{ width: "50%" }}
                />
              </Form.Field>
            ) : null}
            <Form.Field width={16}>
              <label>Nuova password</label>
              <input
                placeholder="Nuova password"
                value={this.state.newPassword}
                onChange={this.handlePassword.bind(this, "new")}
                type="password"
                style={{ width: "50%" }}
              />
              {labelPassword}
            </Form.Field>
            <Form.Field width={16}>
              <label>Ripeti password</label>
              <input
                placeholder="Ripeti password"
                value={this.state.repeatPassword}
                onChange={this.handlePassword.bind(this, "repeat")}
                type="password"
                style={{ width: "50%" }}
              />
              {labelPassword}
            </Form.Field>
            <Button positive onClick={this.updatePassword.bind(this)}>
              {t("MAIN_PROFILE_PWDUPDATE")}
            </Button>
            <Message
              hidden={this.state.error.hidden}
              negative
              icon="exclamation circle"
              header={this.state.error.header}
              content={this.state.error.content}
            />
            <Message
              hidden={this.state.successMessage}
              positive
              icon="check"
              header={"Successo!!!"}
              content={"password cambiata correttamente"}
            />
          </Accordion.Content>
        </Accordion>
      </Form>
    );
  }
}

export default translate("translations")(EditUserForm);



// WEBPACK FOOTER //
// ./src/administration/components/EditUserForm.js